import * as React from 'react'
import clx from 'classnames'
import { Button } from './Button'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  title?: string
  action?: () => void
  header?: React.ReactNode
  actionTitle?: string
  children: React.ReactNode
  className?: string
  classNameContent?: string
  classNameHeader?: string
  noContentPadding?: boolean
  paddingBottom? :boolean
  paddingTop? : boolean
}
export const Card = ({
  title,
  action,
  header,
  children,
  className,
  classNameContent,
  classNameHeader,
  noContentPadding = false,
  actionTitle,
  paddingBottom = true,
  paddingTop = true
}: Props) => {
  const { t } = useLocalize()
  const resolvedActionTitle = actionTitle ?? t('common.show-all')
  return (
    <section
      className={clx(
        `tw-flex tw-flex-col tw-rounded-xl tw-border tw-border-base-300  tw-text-content-base ${paddingTop ? "tw-pt-5" : "tw-pt-0"} ${paddingBottom ? 'tw-pb-5' : 'tw-pb-0'} tw-bg-base-100`,
        className,
      )}
    >
      {(title || action || header) && (
        <header
          className={clx(
            'tw-flex tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-px-4 tw-pb-4',
            classNameHeader,
          )}
        >
          {title && (
            <h3 className="tw-mb-0 tw-text-sm tw-font-medium tw-uppercase">
              {title}
            </h3>
          )}
          {header}
          {action && (
            <Button
              className="tw-text-primary"
              variant="tertiary"
              size="sm"
              status="fill"
              text={resolvedActionTitle}
              onClick={action}
            />
          )}
        </header>
      )}

      <div
        className={clx(
          'tw-inline-block',
          {
            'tw-pt-5': paddingTop,
            'tw-px-3': !noContentPadding,
          },
          classNameContent,
        )}
      >
        {children}
      </div>
    </section>
  )
}
